import PptxGenJS from "pptxgenjs";
import moment from 'moment'
import numeral from 'numeral'

const fcpColor = '#962F45'
const title = 'FRANCO COSIMO PANINI®'

function generatePPT(prodotti, immagini, fields) {
  let pres = new PptxGenJS();

  // 1. SLIDE DI APERTURA (Logo Bianco su sfondo Rosso)
  let slideIntro = pres.addSlide();
  slideIntro.background = { fill: fcpColor };
  slideIntro.addText(title, {
    x: 0, y: 0, w: "100%", h: "100%",
    align: "center", valign: "middle",
    fontSize: 44, color: "FFFFFF", bold: true
  });

  // 2. GENERAZIONE SLIDE PRODOTTI
  prodotti.forEach(prod => {
    let slide = pres.addSlide();

    // Barra laterale rossa con Logo Verticale
    slide.addShape(pres.ShapeType.rect, { 
        x: 0, y: 0, w: 1.2, h: "100%", fill: { color: fcpColor } 
    });
    slide.addText(title, {
      x: -1.5, y: 3, w: 4, h: 1,
      fontSize: 28, color: "FFFFFF", bold: true,
      rotate: -90,
    });

    // Titolo Prodotto
    slide.addText(prod.Descrizione__c, {
      x: 1.5, y: 0.5, w: 8, fontSize: 24, color: fcpColor, bold: true
    });

    // Tabella Dettagli Tecnici
    const rows = []
    for(var f of fields) {
      if(f.fieldname == 'Descrizione__c') continue
      rows.push( [{ text: f.label, options: { bold: true } }, filter(getFieldValue(prod, f.fieldname) || '', f.type)] )
    }

    slide.addTable(rows, {
      x: 1.5, y: 1, w: 4.5,
      fontSize: 12,
      border: { type: "none" },
      fill: { color: "F1F1F1" },
      margin: 5
    });

    // Placeholder Immagine
    let imgurl=immagini.has(prod.Prodotto__c) ? immagini.get(prod.Prodotto__c).replace('http','https') : immagini.get(prod.Prodotto__c)
    console.log(prod.Prodotto__c, imgurl);
    
    if (imgurl) {
      slide.addImage({ 
        path: imgurl,
        x: 6.5, y: 1.5, w: 3, h: 3,
        align: "center", valign: "middle"
      });

    } else {
      slide.addText("NO IMAGE\nAVAILABLE", {
        x: 6.5, y: 1.5, w: 3, h: 3,
        align: "center", valign: "middle",
        fill: { color: "EEEEEE" },
        color: "999999",
        fontSize: 14
      });
    }

    // Footer (Copyright)
    slide.addText("© 2026 - "+title, {
      x: 6.8, y: 5, w: 3, fontSize: 8, color: "999999", align: "right"
    });
    slide.addText("All rights reserved.", {
      x: 6.8, y: 5.1, w: 3, fontSize: 8, color: "999999", align: "right"
    });
  });

  // 3. SLIDE DI CHIUSURA
  let slideOutro = pres.addSlide();
  slideOutro.background = { fill: fcpColor };
  slideOutro.addText("Thank you.", {
    x: 0, y: 2, w: "100%", align: "center", fontSize: 48, color: "FFFFFF", bold: true
  });
  slideOutro.addText(title, {
    x: 0, y: 4.5, w: "100%", align: "center", fontSize: 14, color: "FFFFFF"
  });

  // ESECUZIONE DOWNLOAD
  pres.writeFile({ fileName: "Catalogo_"+new Date().toLocaleString().replaceAll(/,|\/|:/gi ,'_')+".pptx" });
}

import JsBarcode from "jsbarcode";

async function generatePDF(prodotti, immagini, fields) {
  if (!prodotti || !Array.isArray(prodotti)) return;

  // Preload images to ensure jsPDF can embed them properly without throwing synchronous XHR warnings
  await Promise.all(prodotti.map(async (prod) => {
    let imgurl=immagini.get(prod.Prodotto__c);
    if (imgurl) {
      console.log(imgurl);
      
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = imgurl.replace('http','https')
      await new Promise((resolve) => {
        img.onload = resolve;
        img.onerror = resolve;
      });
      prod.imageElement = img;
      console.log('loaded!', img);
    }
  }));
  console.log('after promise all');
  

  const doc = new jspdf.jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4"
  });

  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 15;

  // Helper for applying typography styles globally
  const setTextStyle = (doc, size, style = "normal", color) => {
    doc.setFont("helvetica", style);
    if (size) doc.setFontSize(size);
    if (color !== undefined) {
      Array.isArray(color) ? doc.setTextColor(...color) : doc.setTextColor(color);
    }
  };

  // Helper per il footer (presente in tutte le pagine)
  const drawFooter = (doc) => {
    const yLine = pageHeight - margin - 5;
    doc.setDrawColor(200, 200, 200);
    doc.line(margin - 5, yLine, pageWidth - margin + 5, yLine);

    setTextStyle(doc, 6, "normal", 100);
    doc.text("Franco Cosimo Panini Editore SpA", margin - 5, yLine + 4);
    doc.text("Via Giardini 474 / D - 41124 Modena | Tel. 0592917311 | Fax 0592917381", margin - 5, yLine + 7);
    doc.text("*the -EU code applies for Europe only", pageWidth - margin + 5, yLine + 4, { align: "right" });
  };

  prodotti.forEach((prod, index) => {
    if (index > 0) doc.addPage();

    // Border page
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.2);
    doc.rect(margin - 5, margin - 5, pageWidth - (margin - 5) * 2, pageHeight - (margin - 5) * 2);

    // linea tab
    doc.setFillColor(fcpColor);
    doc.rect(pageWidth - margin + 5, 25, 7, 45, "F");
    setTextStyle(doc, 10, "bold", 255);
    var text = prod.Prodotto__r ? prod.Prodotto__r.Linea__c : ''
    doc.text(text+"®", pageWidth - margin + 9, 67, { angle: 90 });

    const isTopLayout = prod.layout === 'top';
    const startX = isTopLayout ? 20 : margin;
    const titleY = isTopLayout ? 30 : 135;
    const subtitleY = isTopLayout ? 40 : 142;
    const specsY = isTopLayout ? 55 : 152;
    const skuY = isTopLayout ? 55 : 162;

    // Product Image
    if (prod.imageElement && prod.imageElement.complete && prod.imageElement.naturalWidth !== 0) {
      doc.addImage(prod.imageElement, "JPEG", (pageWidth / 2) - 50, 20, 100, 100);
    }

    // Title
    if (prod.Descrizione__c) {
      setTextStyle(doc, isTopLayout ? 20 : 18, "bold", [50, 50, 50]);
      doc.text(prod.Descrizione__c, startX, titleY); 
    }

    for(var i = 0; i < fields.length; i++) {
      // label
      setTextStyle(doc, 11, "bold", [100, 100, 100]);
      doc.text(fields[i].label+': ', startX, subtitleY+5*i);
      //value
      setTextStyle(doc, 11, "normal", [100, 100, 100]);
      var value = filter(getFieldValue(prod, fields[i].fieldname), fields[i].type) || ''
      doc.text(value, startX+30, subtitleY+5*i);
    }

    // Table Data
    if (prod.tableData) {
      doc.autoTable({
        startY: 50,
        body: prod.tableData,
        theme: 'plain',
        styles: { halign: 'center', fontSize: 8, cellPadding: 5 },
        columnStyles: { 0: { cellWidth: 60 }, 1: { cellWidth: 60 }, 2: { cellWidth: 60 } }
      });
    }

    // Specs (Key/Value list)
    if (prod.specs) {
      setTextStyle(doc, 10, "normal", [50, 50, 50]);
      let y = specsY;
      
      prod.specs.forEach(spec => {
        setTextStyle(doc, null, "bold");
        doc.text(spec.label, startX, y);
        setTextStyle(doc, null, "normal");
        
        const offset = spec.label === "Materials:" ? 18 :
                       spec.label === "Product Dimensions:" ? 35 :
                       spec.label === "Packaging:" ? 20 : 20;
        doc.text(spec.value, startX + offset, y);
        
        y += 6;
      });
      
      if (prod.soldPer) {
        y += 2;
        setTextStyle(doc, null, "normal", [100, 100, 100]);
        doc.text(prod.soldPer, startX, y); 
      }
    }

    // SpecsList (Simple Strings array)
    if (prod.specsList) {
      setTextStyle(doc, 10, "normal", [50, 50, 50]);
      doc.text(prod.specsList, startX, specsY);
    }

    // SKU
    if (prod.Prodotto__r.ProductCode) {
      setTextStyle(doc, isTopLayout ? 14 : 9, isTopLayout ? "bold" : "normal", [50, 50, 50]);
      doc.text(prod.Prodotto__r.ProductCode, pageWidth - margin, skuY, { align: "right" });
    }

    // Barcode
    if (prod.Prodotto__r.ITEMBARCODE__c) {
      const canvas = document.createElement('canvas');
      // Clean the barcode text (remove spaces) for generation
      const cleanBarcode = prod.Prodotto__r.ITEMBARCODE__c.replace(/\s/g, '');
      JsBarcode(canvas, cleanBarcode, {
        // format: "UPC",
        displayValue: false,
        margin: 0
      });
      const barcodeImg = canvas.toDataURL("image/png");
      doc.addImage(barcodeImg, 'PNG', pageWidth - margin - 35, skuY + 2, 35, 12);
      
      setTextStyle(doc, 7, "normal", 0);
      doc.text(prod.Prodotto__r.ITEMBARCODE__c, pageWidth - margin, skuY + 17, { align: "right" });
    }

    drawFooter(doc);
  });

  // Salva il PDF
  doc.save("Catalogo_"+new Date().toLocaleString().replaceAll(/,|\/|:/gi ,'_')+".pdf");
}

import ExcelJS from "exceljs";

async function generateXLSX(prodotti, immagini, fields) {
  if (!prodotti || !Array.isArray(prodotti)) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Catalog");

  // Define the columns for the Excel worksheet
  var columns = [
    { header: "Image", key: "image", width: 20 }
  ]
  for(var f of fields) {
    columns.push( { header: f.label, key: f.fieldname, width: 20 } )
  }
  worksheet.columns = columns

  // Style the header row
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(1).alignment = { vertical: "middle", horizontal: "center" };

  for (var i = 0; i < prodotti.length; i++) {
    const prod = prodotti[i];

    // Formatting specifications into a single multiline string
    let specsStr = "";
    if (prod.specs) {
      specsStr = prod.specs.map((s) => `${s.label.trim()} ${s.value.trim()}`).join("\n");
    } else if (prod.specsList) {
      specsStr = prod.specsList.join("\n");
    }

    let r = {}
    for(var f of fields) {
      r[f.fieldname] = filter(getFieldValue(prod, f.fieldname), f.type) || ''
    }
    const row = worksheet.addRow(r)

    // Add sufficient height and format alignment for the image and multiline text
    row.height = 90;
    row.alignment = { vertical: "middle", wrapText: true };

    // Process and attach the image if available
    let imgurl=immagini.has(prod.Prodotto__c) ? immagini.get(prod.Prodotto__c).replace('http','https') : immagini.get(prod.Prodotto__c)
    if (imgurl) {
      try {
        const response = await fetch(imgurl);
        const blob = await response.blob();

        // Convert Blob to Base64
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        const extension = blob.type.includes("png") ? "png" : "jpeg";
        const imageId = workbook.addImage({ base64, extension });

        // Overlay the image into the first column of the current row
        worksheet.addImage(imageId, {
          tl: { col: 0, row: row.number - 1 }, // 0-indexed positioning
          ext: { width: 100, height: 100 },
        });
      } catch (error) {
        console.error(`Failed to load image for SKU: ${prod.sku}`, error);
      }
    }
  }

  // Export the generated workbook
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = window.URL.createObjectURL(blob);

  // Download logic
  const link = document.createElement("a");
  link.href = url;
  link.download = "Catalogo_"+new Date().toLocaleString().replaceAll(/,|\/|:/gi ,'_')+".xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

function getFieldValue (obj, path) {
  for (var i=0, path=path.split('.'), len=path.length; i<len; i++){
    if (obj)
      obj = obj[path[i]];
  }
  return obj;
}

function filter (v, type) { 
  if (!v) return v;
  numeral.locale('it')
  switch(type) {
    case 'date':
      var d=new moment(v);
      return d.format('DD/MM/YYYY');
    case 'datetime':
      var dt=new moment(v);
      return dt.format('DD/MM/YYYY HH:mm');
    case 'number':
        return numeral(v).format('0,0')
    case 'decimal':
      return numeral(v).format('0,0.[0000]');
    case 'currency':
      return numeral(v).format('$ 0.00', Math.floor);
    case 'text':
      return v
  }
  return v
}


export default {
  generatePPT,
  generatePDF,
  generateXLSX
}